import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexTitleSubtitle,
  ApexFill,
  ApexPlotOptions,
  ApexStroke,
  ApexDataLabels,
  ApexLegend,
} from 'ng-apexcharts';
import { ReportTheBestBanks } from '@core/models/statistics-report.model';
import { CapitalizeInitialsPipe } from '@shared/pipes/capitalize-initials.pipe';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  title: ApexTitleSubtitle;
  fill: ApexFill;
  plotOptions: ApexPlotOptions;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
};

@Component({
  selector: 'app-bank-most-reports',
  templateUrl: './bank-most-reports.component.html',
  styleUrls: ['./bank-most-reports.component.scss'],
  providers: [CapitalizeInitialsPipe],
})
export class BankMostReportsComponent implements OnInit, OnChanges {
  @Input() statisticsTheBestBanks: ReportTheBestBanks[] = [];

  public chartOptions: Partial<ChartOptions>;

  constructor(
    private readonly capitalizeInitialsPipe: CapitalizeInitialsPipe,
  ) {}

  ngOnInit(): void {
    this.buildChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.statisticsTheBestBanks) {
      this.buildChart();
    }
  }

  private buildChart(): void {
    if (
      !this.statisticsTheBestBanks ||
      this.statisticsTheBestBanks.length === 0
    ) {
      return;
    }

    const namesBanks = this.statisticsTheBestBanks.map((b) =>
      this.capitalizeInitialsPipe.transform(b.bankName),
    );

    const namesAmount = this.statisticsTheBestBanks.map((b) => b.amount);
    const totalAmount = namesAmount.reduce((a, b) => a + b, 0);

    this.chartOptions = {
      series: namesAmount,
      chart: {
        type: 'donut',
        height: 320,
      },
      labels: namesBanks,
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'horizontal',
          inverseColors: false,
          opacityFrom: 0.9,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      plotOptions: {
        pie: {
          donut: {
            size: '60%',
            labels: {
              show: true,
              name: {
                show: true,
                color: '#000000',
                fontSize: '8px',
              },
              value: {
                show: true,
                color: '#000000',
                fontSize: '14px',
                formatter: (val) => `$${Number(val).toLocaleString()}`,
              },
              total: {
                show: true,
                label: 'Total',
                color: '#000000',
                formatter: () => `$${totalAmount.toLocaleString()}`,
              },
            },
          },
        },
      },
      stroke: {
        show: true,
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        labels: {
          colors: '#000000',
        },
        fontSize: '12px',
        markers: {
          width: 10,
          height: 10,
          radius: 10,
        },
      },
    };
  }
}
